var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-transfer',{staticStyle:{"text-align":"left","display":"inline-block"},attrs:{"filterable":"","props":{
    key: 'id',
    label: 'username',
  },"titles":['未分组', _vm.rightGourpsTitle],"format":{
    noChecked: '${total}',
    hasChecked: '${checked}/${total}',
  },"data":_vm.options},model:{value:(_vm._value),callback:function ($$v) {_vm._value=$$v},expression:"_value"}})}
var staticRenderFns = []

export { render, staticRenderFns }